export const getFileExtension = (filename = "") => {
  const parts = filename.split(".");

  return parts.length ? parts.pop().toLowerCase() : "";
};
